let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b0WL4")).then(() => parcelRequire('lvv6C'));